import themeVariables from "@/config/theme/themeVariable";
import { useFetchTags } from "../_hook";
import Link from "next/link";
import { getLanguage } from "@/utils/localStorageControl";

interface TagSidebarProps {
  className?: string;
}

export default function TagSidebar({ className = "" }: TagSidebarProps) {
  const { data: tags } = useFetchTags();
  const language = getLanguage();

  return (
    <div className={`bg-white rounded-lg lg:p-6 ${className}`}>
      {/* Topics Section */}
      <div className="mb-8">
        <h3 className="text-gray-900 font-semibold mb-4">Choose topics</h3>
        <div className="flex flex-wrap gap-1.5">
          {tags?.result[language].map((topic: any) => (
            <Link href={`/blogs?tag=${topic}`} key={topic}>
              <span className={`${themeVariables.badge.light} cursor-pointer hover:bg-gray-200 transition-colors duration-150`}>
                {topic}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
} 